import { tSharedAppState, tSharedStore } from 'common/modules/ReactShared';
import { createSelector, Selector } from '@reduxjs/toolkit';
import parentSelectors from '../selectors';
import { tAssignmentsTab } from './types';

type tAssignmentsState = tSharedStore['member']['assignmentsPage'];
type tTabState = tAssignmentsState[tAssignmentsTab];

const selectStore: Selector<tSharedAppState, tAssignmentsState> = createSelector(
  [parentSelectors.selectMemberStore],
  (parent) => parent.assignmentsPage
);

const selectTab = (tab: tAssignmentsTab): Selector<tSharedAppState, tTabState> =>
  createSelector([selectStore], (store) => store[tab]);

const selectors = {
  selectStore,
  selectTab
};

export { selectors };
